import { Row } from "reactstrap";
import { eqTimeSlots } from "../../../utils/equipTime";
import { getJSTDateStr } from "../../../utils/dateformatter";

export const EqTimeSlots = ({
  onSelect,
  selectedTime,
  selectedDate,
  latestTime,
  startDate,
  startTime,
}) => {
  const today = getJSTDateStr();
  const toMinutes = (t) => {
    const [h, m] = t.split(":").map(Number);
    return h * 60 + m;
  };

   const isToday = today === selectedDate;
 
  const displaySlots1 =
    isToday && selectedTime
      ? eqTimeSlots.filter((time) => toMinutes(time) >= toMinutes(selectedTime))
      : eqTimeSlots;
      const displaySlots = isToday
    ? eqTimeSlots.filter((time) => toMinutes(time) >= toMinutes(latestTime))
    : eqTimeSlots;
 
  return (
    <div className=" eqTimeSlot ">
      {displaySlots.map((time, index) => {
        const isSelected = time === selectedTime;
        const isToday = today === selectedDate;
        const isSame= startDate === selectedDate;
        const isDisabled = (isToday && toMinutes(time) < toMinutes(latestTime)) || (isSame && toMinutes(time) <= toMinutes(startTime));
        return (
          <Row
            key={index}
            className={` py-1 border mx-0 cursor-pointer  
              ${isSelected ? "selectedSlot" : ""}
               ${isDisabled? "disabled" : ""}
              `}
            // onClick={() => onSelect(time)}
            onClick={() => {
              if (!isDisabled) {
                onSelect(time);
              }
            }}
          >
            <span className={`   ${isSelected ? "selectedSlot" : "times"}`}>
              {time}
            </span>
          </Row>
        );
      })}
    </div>
  );
};
